import { Injectable } from '@angular/core';
declare let ga: any;

@Injectable()
export class GoogleAnalyticsService {

  constructor() { }

  public emitEvent(eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {
    ga('send', 'event', 
    { eventCategory: eventCategory, 
      eventLabel: eventLabel, 
      eventAction: eventAction, 
      eventValue: eventValue
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/google-analytics.service.ts